import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useDeliveryBoyMapApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllDeliveryBoyMap = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        
        const response = await api.searchDeliveryBoys(
          query.name,
          query.latitude,
          query.longitude,
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );



  
 

  return {
    getAllDeliveryBoyMap,
    loading,
    error,
  };
};
